class GroupCode {
  constructor() {
    this.SALES = 1
    this.COST = 2
    this.EXPENSE = 3
  }
}

export default new GroupCode()
